"use client";

// @ts-nocheck
import { ReactNode } from 'react';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

export default function Providers({ children }: { children: ReactNode }) {
  return (
    <MantineProvider
      theme={{
        // @ts-ignore
        colorScheme: 'dark',
        colors: {
          brand: ['#0d1117', '#161b22', '#30363d', '#58a6ff', '#0d1117', '#161b22', '#30363d', '#58a6ff', '#0d1117', '#161b22'],
        },
      } as any}
    >
      {children}
      <Notifications 
        position="top-right" 
        zIndex={9999}
        limit={5}
      />
    </MantineProvider>
  );
}
